import { render, staticRenderFns } from "./ReportGlobalvalueLife.vue?vue&type=template&id=d13471d0&scoped=true&"
import script from "./ReportGlobalvalueLife.vue?vue&type=script&lang=js&"
export * from "./ReportGlobalvalueLife.vue?vue&type=script&lang=js&"
import style0 from "./ReportGlobalvalueLife.vue?vue&type=style&index=0&id=d13471d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13471d0",
  null
  
)

export default component.exports